import React from 'react';
import './ApproveRejectCard.scss';
import { AppAssetPaths } from '../../app/app.types';
import { Tooltip } from '@mui/material';


interface ApproveRejectCardProps {
  onApprove: () => void;
  onReject: () => void;
  approveText?: string;
  disabled?: boolean;
  disabledTooltip?: string;
}

const ApproveRejectCard: React.FC<ApproveRejectCardProps> = ({
  onApprove,
  onReject,
  approveText = 'Approval Needed',
  disabled = false,
  disabledTooltip = '',
}) => {

  const card = (
    <div className={`approve-reject-container flex_row_jcenter_acenter${disabled ? ' disabled' : ''}`}>
      <p>{approveText}</p>
      <img
        src={AppAssetPaths.icons.statusIcons.APPROVE}
        alt="Approve"
        onClick={disabled ? undefined : onApprove}
      />
      <img
        src={AppAssetPaths.icons.statusIcons.REJECT}
        alt="Reject"
        onClick={disabled ? undefined : onReject}
      />
    </div>
  );

  if (disabled && disabledTooltip) {
    return (
      <Tooltip title={disabledTooltip} arrow>
        <span className="approve-reject-tooltip-wrapper">{card}</span>
      </Tooltip>
    );
  }

  return card;
};

export default ApproveRejectCard;
